import React, { useState, useEffect } from 'react'
import { ContentCon, HubTabsHead } from './styles'
import { TabPanel } from '../../../Components/Tab/TabPanel'
import { EventGQL, EventHubData } from '../../../Api'
import { Gameday } from './Gameday'
import { MatchupSlider } from '../matchupSlider'
import { Tab } from '../../../Components/LazyComponents'

type HubTabsParams = {
  hubInfo: EventHubData | null
  events: EventGQL[]
}

export const HubTabs: React.FC<React.PropsWithChildren<HubTabsParams>> = ({ hubInfo, events }) => {
  const [value, setValue] = useState(0)

  useEffect(() => {}, [])

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  return (
    <>
      <HubTabsHead
        value={value}
        onChange={handleChange}
        aria-label="transactions tabs"
        indicatorColor="primary"
      >
        <Tab label={`Gameday`} />
        <Tab label={`Matchups`} />
      </HubTabsHead>
      <TabPanel value={value} index={0}>
        <ContentCon>
          <Gameday hubInfo={hubInfo} />
        </ContentCon>
      </TabPanel>
      <TabPanel value={value} index={1}>
        {events?.length > 0 && (
          <ContentCon>
            <MatchupSlider events={events} />
          </ContentCon>
        )}
      </TabPanel>
    </>
  )
}
